import { Injectable } from '@angular/core';
import { ApiConfig } from '../config/apiConfig';
import { HttpClient, HttpParams,HttpHeaders } from '@angular/common/http';
import { ConfService } from 'src/conf.service';
import { Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  private rootUrl: string;
  private resourceAPIUrl;

  constructor(private http: HttpClient) {
    this.rootUrl = ConfService.conf.environment.apiRootUrl;
    this.resourceAPIUrl = ApiConfig.ResourceApiConfig;
   }

  	
	getResourcesSP(resourceObj: any): Observable<any> {    
    return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.getResourcesSP}`, resourceObj)  
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getResourceFiles(resourceObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.getResourceFiles}`, resourceObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	getResources(resourceObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.getResources}`, resourceObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}

	
	createResourceFile(resourceObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.createResourceFile}`, resourceObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	createResource(resourceObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.createResource}`, resourceObj)
      .pipe(
        tap(() => {
          //
        })
      );
	}
	
	updateResource(resourceObj: any): Observable<any> {
		return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.updateResource}`, resourceObj)
      .pipe(
        tap(() => {
          //
        })
      );
  } 

  //File Upload
  uploadFile(file) {      
    let url=`${this.rootUrl}${this.resourceAPIUrl.uploadFile}`;    
    const formData: FormData = new FormData();
    formData.append('file', file[0], file[0].name);   
    return this.http.post(url, formData);
  }
  
  //Get AvailableFiles 
  AvailableFiles(): Observable<any> {    
    return this.http.post(`${this.rootUrl}${this.resourceAPIUrl.availableFiles}`,null)    
      .pipe(
        tap(() => {
          //
        })
      );
  }
}
